import { PriceIndividualModel } from ".";

export class PriceConditionModel {
    public priceConditionId: string;
    public referencePriceConditionId: string;
    public conditionCode: string;
    public numberOfUnits: number;
    public statusCode: string = 'A';
    public individuals = new Array<PriceIndividualModel>();
}